var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@increasecard/typed-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  transition: opacity 200ms ease-in-out;\n  pointer-events: none;\n  opacity: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  transition: opacity 200ms ease-in-out;\n  pointer-events: none;\n  opacity: ", ";\n"])), function (_a) {
    var active = _a.active;
    return (active ? 0.9 : 0);
});
export function LoadingOverlay(_a) {
    var active = _a.active, children = _a.children, wrapperStyle = _a.wrapperStyle, style = _a.style, rest = __rest(_a, ["active", "children", "wrapperStyle", "style"]);
    return (React.createElement("div", __assign({ style: __assign(__assign({}, wrapperStyle), { position: 'relative' }) }, rest),
        children,
        React.createElement(Wrapper, { active: active, style: style },
            React.createElement(Spinner, { size: 72 }))));
}
var templateObject_1;
